var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tag tag-color",staticStyle:{"margin-right":"5px","margin-top":"5px"},style:(_vm.dynamicStyle),attrs:{"href":""}},[_vm._v(_vm._s(_vm.data.text))])}
var staticRenderFns = []

export { render, staticRenderFns }